export const SET_FORECAST_GWC = "SET_FORECAST_GWC"
